import { Component, Schema, type, defaultValue } from "minecs";
@Component()
export class AirportStation extends Schema {
    @type("number")
    @defaultValue(0)
    index: number;
    @type("number")
    @defaultValue(0)
    level: number;
    @type("boolean")
    @defaultValue(false)
    unlocked: boolean;
    @type("boolean")
    @defaultValue(false)
    manager: boolean;
    @type("number")
    @defaultValue(0)
    pending: number;
    @type("number")
    @defaultValue(0)
    served: number;
    @type("number")
    @defaultValue(0)
    invested: number;
    @type("number")
    @defaultValue(0)
    activeWorkers: number;
    @type("number")
    @defaultValue(0)
    assignedWorkers: number;
    @type("number")
    @defaultValue(0)
    busy: number;
    @type("number")
    @defaultValue(0)
    queueLength: number;
    @type("number")
    @defaultValue(1)
    lanes: number;
    @type("number")
    @defaultValue(0)
    speedLevel: number;
    @type("number")
    @defaultValue(0)
    incomeLevel: number;
    @type("number")
    @defaultValue(0)
    upgradeUntil: number;
    @type("number")
    @defaultValue(0)
    dividerLevel: number;
    @type("number")
    @defaultValue(0)
    dividerUntil: number;
}
